import * as actionTypes from './actionTypes';

export const signIn = ({ uid, email, isLogged, isAdmin, userType, displayName }) => {
    return {
        isLogged,
        uid,
        email,
        isAdmin,
        userType,
        displayName,
        type: actionTypes.AUTH_SIGN_IN
    }
}

export const signOut = () => {
    console.log('SIGN oUt')
    return {
        type: actionTypes.AUTH_SIGN_OUT
    }
}